











































import { Component, Vue } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
import searchState from '@/store/search';
import User from '@/store/user';
import Customer from '@/models/customerModel';
import {
  FieldChildrenProp,
  GetItemsResponse,
  Items,
  StatusActions,
  ActionButtons,
  ItemActions,
  DatastoreActons
} from '@/services/hexabase/types'
import {
  ColumnList,
  SearchPanelColumnWidth,
  sampleStatusId,
  DetailNotFoundMessage,
  bulkMessage,
  CustomerSearchColumnList,
  CustomerSearchDateItemlist,
  CustomerListActionButton,
  CustomerSearchExclusionStatus,
  CustomerDefaultSort,
  buttonItems,
  Messages
} from '@/constants/customer/customerList';
import { listPerPage } from '@/constants/util';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import SearchPanel from '@/components/common/modules/list/SearchPanel.vue';
import SearchList from '@/components/common/modules/list/SearchList.vue';
import { searchFormCustomer } from '@/constants/form/search';

import ActionButtonWithSearchPanel from '@/components/common/modules/ActionButtonWithSearchPanel.vue';

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    SearchPanel,
    SearchList,
    ActionButtonWithSearchPanel
  }
})
/* eslint-disable @typescript-eslint/camelcase */
export default class CustomerList extends Vue {
  private employeeId = User.getUserEmployeeId;
  private customer = new Customer;
  private statusButton = CustomerListActionButton;
  private execAllowActions: any = [];

  // アプリIDをセット
  private projectId = hexabaseState.applicationId;
  // dbID格納プロパティ
  private mainDsId = '';
  private relatedDsId = '';
  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  // アイテム取得時Param
  /* eslint-disable @typescript-eslint/camelcase */
  private payload = {
    conditions: [] as Array<{[key: string]: string | string[] | boolean}>,
    per_page: listPerPage,
    page: 1,
    use_display_id: true,
    include_links: true,
    include_lookups: true,
    sort_fields: [...CustomerDefaultSort]
  };
  // 各入力フィールド情報格納プロパティ
  private searchFieldsData: Array<FieldChildrenProp> = [];
  private searchFieldCols = '';
  private statusList: any = {};
  // 一覧表示部分に使用
  private fieldsData: any = {}
  private apiResponseData: GetItemsResponse = { items:[], totalItems:0 };
  private colums: Array<{[k: string]: string | number}> = [];
  // ページネーション情報
  private page = {
    currentPage: 1,
    totalPage: 1,
    totalItem: 0,
    visible: 8,
    perPage: listPerPage
  }
  private apiResult = false;
  // 一括処理用プロパティ
  private bulkMessage = bulkMessage;
  private dialogStatus = false;
  private isFlush = false;
  private selectItems: Array<Items> = []; // 一括処理に渡すアイテム情報
  private selectActions: Array<StatusActions> = []; // 一括処理に渡す次アクション情報
  private bulkApiResponse: {[k: string]: any} = {}; // 一括処理実行後のAPIレスポンス

  private detailDialogStatus = false;
  private detailItems: Array<{[k: string]: string | any}> = [];
  private detailDialogMessage = '';

  private numberOfSelection = 0;
  private descriptiveText = 'ここにガイダンス文言を設定できます。\nここにガイダンス文言を設定できます。';

  private buttonItems = buttonItems;

  // 検索文言
  private dataTableText = Messages.dataTableText;

  async created() {
    try{
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      this.mainDsId = hexabaseState.datastoreIds['顧客マスタ'];
      const [
        fieldsData,
        execAllowActions,
        masterData
      ] = await Promise.all([
        this.customer.getField(this.projectId, this.mainDsId),
        this.customer.getNewActionList(this.mainDsId).then(data => data.actions),
        this.customer.getMasterData()
      ]);
      // マスターデータを取得しグローバル変数に格納
      this.masterData = this.customer.getMaster();
      // 新規登録権限を取得
      this.execAllowActions = execAllowActions;
      // 自動生成コンポーネント用にプロパティー設定
      this.fieldsData = fieldsData;
      this.searchFieldsData = this.customer.createSearchConf(this.fieldsData, this.masterData, searchFormCustomer);
      this.searchFieldCols = `${SearchPanelColumnWidth}% `.repeat(100/SearchPanelColumnWidth); //検索フォームは表示を均等にするため固定

      // ステータス検索が無くなった為一旦コメント
      // ステータス検索用にステータスリストをマージ
      // this.statusList = statusList;
      // const deleteStatusIndex = this.statusList[0].statuses.findIndex((status: { status_name: string; }) => status.status_name === '削除済');
      // if (deleteStatusIndex > 0) {
      //   this.statusList[0].statuses.splice(deleteStatusIndex, 1);
      // }
      // this.searchFieldsData = this.customer.setStatusBySelectProp(this.searchFieldsData, this.statusList[0].statuses);

      // 初期表示データ取得・作成
      // 検索Stateが存在していたら検索項目に値をセットする
      const stateCondition = searchState.searchCondition !== undefined ? searchState.searchCondition : [];
      for (const key in stateCondition) {
        const setConditionIndex = this.searchFieldsData.findIndex(field => field.display_id === stateCondition[key].id);
        if (setConditionIndex >= 0) {
          const dataType = this.searchFieldsData[setConditionIndex].dataType;
          switch (dataType) {
            case 'dslookup':
              this.searchFieldsData[setConditionIndex].props!.value = { item_id: stateCondition[key].search_value[0] };
              break;
            case 'status':
              this.searchFieldsData[setConditionIndex].props!.value = stateCondition[key].search_value[0];
              break;
            case 'datetime':
              this.searchFieldsData[setConditionIndex].props!.valueFrom = stateCondition[key].search_value[0];
              this.searchFieldsData[setConditionIndex].props!.valueTo = stateCondition[key].search_value[1];
              break;
            default:
              this.searchFieldsData[setConditionIndex].props!.value = stateCondition[key].search_value[0];
              break;
          }
        }
      }

      // 検索条件を与えられている場合、検索結果を取得
      if ('searchConditions' in this.$route.query) {
        await this.getItems(stateCondition);
      } else {
        this.apiResult = true;
      }

      // 一覧カラム設定
      this.colums = this.customer.createColumns(CustomerSearchColumnList, this.fieldsData.fields);
      this.colums.map(v => { if(v.name === sampleStatusId){ v.text = 'ステータス'} return v; });
    } catch(e) {
      console.log(e);
      this.setError(e);
    }
    finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 一覧表示するアイテムを取得する
   * @param {array} condition - 検索条件を指定する
   * @param {number} page - 検索オフセット情報
   * @returns {void} 各内部プロパティに情報セット
   */
  async getItems(condition?: Array<{[key: string]: string[]}>, page?:number){
    if (condition !== undefined && condition.length > 0) {
      for (const key in searchState.searchCondition) {
        const findData = condition.find(recode => recode.id === searchState.searchCondition![key].id);
        if (!findData) {
          condition.push(searchState.searchCondition[key]);
        } else {
          const setConditionIndex = this.searchFieldsData.findIndex(field => field.display_id === searchState.searchCondition[key].id);
          if (setConditionIndex >= 0) {
            const componentType = this.searchFieldsData[setConditionIndex].component;
            switch (componentType) {
              case 'DatePickerRangeArea':
                if (searchState.searchCondition[key].search_value[0] && !findData.search_value[0]) {
                  findData.search_value[0] = searchState.searchCondition[key].search_value[0];
                }
                if (searchState.searchCondition[key].search_value[1] && !findData.search_value[1]) {
                  findData.search_value[1] = searchState.searchCondition[key].search_value[1];
                }
                break;
              default:
                break;
            }
          }
        }
      }
      searchState.setConditions(condition);
    }
    this.apiResult = false;
    if (condition !== undefined) {
      // conditionsに固定条件を付与するためconcatで参照渡しを回避する
      this.payload['conditions'] = condition.concat();
    }
    this.payload['page'] = page !== undefined ? page : 1 ;

    // 「ステータス：削除済」は必ず除外
    this.payload['conditions'].push({
      'id': sampleStatusId,
      'search_value': CustomerSearchExclusionStatus,
      'not_match': true
    });

    try{
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      this.apiResponseData = await this.customer.getItemSearch(this.projectId, this.mainDsId, this.payload);

      if (this.apiResponseData.errors !== undefined) {
        this.dataTableText = this.customer.getErrMessage('ITEMLIST', this.apiResponseData);
      } else if (this.apiResponseData.items.length === 0) {
        this.dataTableText = this.customer.getMessage('ITEMLIST', 'NOT_FOUND');
      }
    } catch(e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
      this.apiResult = true;
    }

    for (const key in this.apiResponseData.items) {
      // 定義ファイルで指定した日付の表示形式変更
      for (const index in CustomerSearchDateItemlist) {
        if (
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]] !== undefined &&
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]] !== null &&
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]].length > 0
        ) {
          const date = this.apiResponseData.items[key][CustomerSearchDateItemlist[index]];
          this.apiResponseData.items[key][CustomerSearchDateItemlist[index]] = this.customer.editDatetype(date, 'Asia/Tokyo', '');
        }
      }
    }

    // アイテム数等をセット
    this.page.totalItem = this.apiResponseData.totalItems, listPerPage;
    this.page.totalPage = this.customer.getTotalPage(this.apiResponseData.totalItems, listPerPage);
    this.page.currentPage = this.payload['page'];
  }

  /**
   * 検索パネルにて「リセット」ボタン押下時
   * 内部プロパティの検索情報を消去する
   * @returns void 内部プロパティ消去
   */
  private resetSearchForm(): void{
    this.payload.conditions.splice(0);
    this.payload.page = 1;
  }

  /**
   * ページネーションボタンが押下された際
   * 指定ページの情報を問い合わせに行く
   * @param {number} response - 子コンポーネントから渡ってきたページ番号
   * @returns void API問い合わせ
   */
  private pageNaviAction(response: number){
    this.getItems(undefined, response);
  }

  /**
   * 検索結果、ボタン押下時の各処理を記載
   * @param response - クリックしたボタンタイプ、インデックス、レコード情報
   * @return void - 内部プロパティ変更
   */
  private clickButton(response: { [k: string]: any }){
    switch (response.buttonName) {
      case 'detail': {
        // 顧客詳細編集画面に遷移
        this.$router.push({ name: 'CustomerEdit', params: { id: response.record.i_id }, query: { searchConditions: 'true' } });
        break;
      }
    }
  }

  /**
   * 検索結果レコードのチェックボックスハンドリング
   * selectItemsで受け取り、件数表示へ選択件数を渡す
   * @param selectItems - 選択レコード情報
   * @return void - 内部プロパティ変更
   */
  private selectItemHandle(selectItems: any) {
    this.numberOfSelection = selectItems.length;
    this.selectItems.splice(0);
    this.selectItems.push(...selectItems);
  }

  /**
   * 明細表示にて閉じるボタンが押下された際の処理
   */
  private detailClose(){
    this.detailDialogMessage = '';
    this.detailDialogStatus = false;
    this.detailItems.splice(0);
  }

  private getDetailLabel() {
    return [
            { text: '品目', value: 'item_id', },
            { text: '発注数量', value: 'order_quantity' },
            { text: '単位', value: 'unit_id' },
            { text: '単価', value: 'unit_price' },
            { text: '金額', value: 'amount' },
            { text: '消費税', value: 'tax' },
            { text: '課税区分', value: 'tax_class_id' }
        ];
  }

  // 以下一括アクション処理

  /**
   * 一括処理ボタン押下時処理
   * 選択されたアイテムの次に利用できるステータスアクションを取得
   * @param {array} - テーブルよりセレクトされたアイテム
   * @returns {void} - 内部プロパティ変更
   */
  public bulkActionPopupHandle() {
    this.isFlush = false;
    this.dialogStatus = false;
    if (this.selectItems.length > 0) {
      // ローディングセット
      this.$store.commit('hexabase/setIsLoading', true);
      // 利用できるステータスアクションを取得
      this.customer.getExecutableStatusAction(this.projectId, this.mainDsId, this.selectItems[0].i_id)
      .then(data => {
        this.selectActions.splice(0);
        this.selectActions.push(...data);
      })
      .catch(e => {
        // TODO: 共通エラーコンポーネント実装予定
        console.log(e);
        this.selectActions.splice(0);
        this.setError(e);
      })
      .finally(() => {
        this.$store.commit('hexabase/setIsLoading', false);
        this.dialogStatus = true;
      });
    } else {
      this.dialogStatus = true;
    }
  }

  /**
   * 一括処理の実行
   * @param {[k: string]: string | number} action - ステータスアクションID
   * @returns {void} - バルクアクションAPIのレスポンスを内部プロパティに格納
   */
  public async execBulkAction(action: {[k: string]: string | number}){

    try{
      this.dialogStatus = false;
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      const relateActionName = this.customer.detailActionName(action.display_id as string);

      // 見出し必須項目を設定
      const orderInput: {[k: string]: any} =await this.customer.getMainRequired(this.mainDsId, action);

      // 詳細必須項目取得
      const orderDetailInput: {[k: string]: any} = await this.customer.getLinkRequired(
        this.projectId,
        this.relatedDsId,
        this.selectItems,
        relateActionName
      );

      // 処理実行
      const errors:Items[] = await this.customer.multipleProcesses(
        this.selectItems,
        this.projectId,
        this.mainDsId,
        this.relatedDsId,
        orderInput,
        orderDetailInput,
        action,
        User.getUserEmployeeId
      );

      if (errors.length > 0){
        this.bulkApiResponse = {...{errors:errors}}
      } else {
        this.bulkApiResponse = {...{data:{}}}
      }
    } catch(e) {
      console.log(e);
      this.setError(e);
    }
    finally {
      this.$store.commit('hexabase/setIsLoading', false);
      this.dialogStatus = true;
    }

  }

  /**
   * 一括処理ポップアップのキャンセルボタン押下時処理
   * @returns {void} - ポップアップ状態変更（閉じる）
   */
  private catchPopup(): void {
    this.dialogStatus = false;
  }

  /**
   * 一括処理ポップアップの処理完了時確認ボタン押下時処理
   * ポップアップを閉じる前に
   * ・アイテム一覧に対し再検索（一括処理前のコンディションで）
   * ・テーブルの選択アイテムなど内部で保持している情報削除
   * @returns {void} - 内部プロパティ変更
   */
  private successOpratipon(): void {
    try{
      this.getItems();
      this.popupInit();
    } catch(e) {
      console.log(e);
      this.setError(e);
    }
  }

  /**
   * 一括処理完了後内部で保持しているプロパティを消去
   * ・一覧テーブルで選択したアイテム
   * ・一覧テーブルで選択したアイテムに紐づくステータスアクション
   * ・一括処理APIレスポンス
   * @returns {void} - 内部プロパティ変更
   */
  private popupInit() {
    this.selectItems.splice(0);
    this.selectActions.splice(0);
    this.bulkApiResponse = {};
    this.isFlush = true;
    this.dialogStatus = false;
  }

  private buttonAction(event:any) {
    if('新規登録' === event) {
      this.$router.push({ name: 'CustomerRegister' });
    }
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.customer.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
